export enum AnalyticsEvents {
  NavigationClickToWidget = 'navigation.clickToWidget',
  NavigationInPageTabClick = 'navigation.inPageTabClick',
  SearchModalSearchClick = 'search.ModalSearchClick',
  NavigationClickToCopy = 'navigation.clickToCopy',
  NavigationClickToModal = 'navigation.clickToModal',
  NavigationClickToCompare = 'navigation.clickToCompare',
  NavigationClickToView = 'navigation.clickToView',
  NavigationClickToComparison = 'navigation.clickToViewComparison',
  NavigationLinkClick = 'navigation.linkClick',
  SearchSort = 'search.sort',
}

export enum AnalyticsEventTypes {
  CarSearchWidget = 'car search widget',
  Share = 'share',
  RefineCarSearch = 'refine car search',
  CarCompare = 'car compare',
  CarResults = 'car results',
  CarSearch = 'car search',
  Tabs = 'tabs',
  Promo = 'promo',
  ExplanationLink = 'explanation link',
  ReviewLink = 'review link',
}

export enum AnalyticsEventNames {
  CompareFromResults = 'compare from results',
  ViewComparison = 'view comparison',
  View = 'view',
  CopyLink = 'copy link',
  ShareToEmail = 'share to email',
  CarLoanCalculator = 'car loan calculator',
  ApplyForACarLoan = 'apply for a car loan',
  InsuranceQuote = 'insurance quote',
  RoadsideQuote = 'roadside assistance quote',
  Price = 'price',
  Year = 'year',
  BodyType = 'body type',
  FuelType = 'fuel type',
  RefineCarSearch = 'refine car search',
  Make = 'make',
  ReadFullReview = 'read full review',
}
